export default function ProductsSection() {
  return (
    <section id="products" className="w-full py-24 md:py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex items-center gap-2 mb-4">
          <span className="w-8 h-px bg-gray-400" />
          <span className="text-xs font-semibold tracking-widest uppercase text-gray-400">Our Products</span>
        </div>
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-14">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
            Crafted for iOS.<br />Built for You.
          </h2>
          <p className="text-gray-400 text-base max-w-xs md:text-right leading-relaxed">
            Two powerful applications designed to protect and optimize your mobile experience.
          </p>
        </div>

        {/* Product Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* VPN Card */}
          <div className="group relative rounded-3xl overflow-hidden bg-gradient-to-br from-slate-900 to-slate-800 p-8 md:p-10 flex flex-col min-h-[480px]">
            {/* Background image */}
            <div className="absolute inset-0 opacity-20">
              <img
                src="https://public.readdy.ai/ai/img_res/33b422f29d5ceea3811f20dbfcd6b741.jpg"
                alt=""
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-transparent to-transparent" />

            <div className="relative z-10 flex flex-col h-full">
              {/* Icon */}
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-sky-500/20 border border-sky-400/30 mb-6">
                <i className="ri-shield-keyhole-line text-sky-400 text-2xl" />
              </div>

              <div className="mb-auto">
                <span className="text-sky-400 text-xs font-semibold tracking-widest uppercase mb-3 block">Security</span>
                <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">VPN</h3>
                <p className="text-gray-300 text-base leading-relaxed mb-6">
                  A fast, reliable Virtual Private Network application for iOS. Protect your internet connection with military-grade encryption, mask your IP address, and browse the web with complete anonymity — wherever you are.
                </p>
              </div>

              {/* Features list */}
              <div className="flex flex-col gap-3 mt-6">
                {[
                  "Military-grade AES-256 encryption",
                  "Zero-log privacy policy",
                  "One-tap connection",
                  "Global server network",
                ].map((f) => (
                  <div key={f} className="flex items-center gap-3">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-check-line text-sky-400 text-sm" />
                    </div>
                    <span className="text-gray-300 text-sm">{f}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Cleaner Card */}
          <div className="group relative rounded-3xl overflow-hidden bg-gradient-to-br from-emerald-900 to-teal-900 p-8 md:p-10 flex flex-col min-h-[480px]">
            {/* Background image */}
            <div className="absolute inset-0 opacity-20">
              <img
                src="https://readdy.ai/api/search-image?query=abstract%20phone%20optimization%20and%20cleaning%20visualization%20with%20glowing%20particles%20and%20speed%20lines%20on%20dark%20background%2C%20performance%20boost%20digital%20art%2C%20green%20and%20teal%20colors%2C%20minimal%20geometric%20patterns&width=800&height=960&seq=cleaner001&orientation=portrait"
                alt=""
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-teal-900/90 via-transparent to-transparent" />

            <div className="relative z-10 flex flex-col h-full">
              {/* Icon */}
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-emerald-400/20 border border-emerald-400/30 mb-6">
                <i className="ri-sparkling-2-line text-emerald-400 text-2xl" />
              </div>

              <div className="mb-auto">
                <span className="text-emerald-400 text-xs font-semibold tracking-widest uppercase mb-3 block">Performance</span>
                <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">Cleaner</h3>
                <p className="text-gray-300 text-base leading-relaxed mb-6">
                  A smart iOS optimization tool that removes junk files, clears cache, and frees up valuable storage space. Keep your iPhone running at peak performance with intelligent, automated cleaning routines.
                </p>
              </div>

              {/* Features list */}
              <div className="flex flex-col gap-3 mt-6">
                {[
                  "Smart junk file detection",
                  "Duplicate photo removal",
                  "Cache & temp file cleanup",
                  "Storage space analyzer",
                ].map((f) => (
                  <div key={f} className="flex items-center gap-3">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-check-line text-emerald-400 text-sm" />
                    </div>
                    <span className="text-gray-300 text-sm">{f}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
